export const ActionType = {
  OPEN_COLOR_PICKER: "OPEN_COLOR_PICKER",
  CLOSE_COLOR_PICKER: "CLOSE_COLOR_PICKER",
  SET_COLOR: "SET_COLOR",
};
